import { getError } from '../../utils/requestUtils';
import {
  CLEAN_SALES_LEADERBOARD,
  ERROR,
  LIST_SALES_LEADERBOARD,
  SET_SALES_LEADERBOARD_FILTERS,
  START,
  SUCCESS
} from '../actions/types';

const INITIAL_STATE = {
  salesLeaderboard: [],
  pagination: null,
  filters: {},

  listSalesLeaderboard: {}
};

export default function reducer(state = INITIAL_STATE, action) {
  const data = action.payload?.data;
  const error = getError(action.payload);

  switch (action.type) {
    case LIST_SALES_LEADERBOARD + START:
      return { ...state, listSalesLeaderboard: { loading: true } };
    case LIST_SALES_LEADERBOARD + SUCCESS:
      return {
        ...state,
        listSalesLeaderboard: { loading: false },
        salesLeaderboard: data.result.items,
        pagination: data.result.pagination
      };
    case LIST_SALES_LEADERBOARD + ERROR:
      return { ...state, listSalesLeaderboard: { loading: false, error } };

    case CLEAN_SALES_LEADERBOARD + SUCCESS:
      return {
        ...state,
        listSalesLeaderboard: { loading: false },
        salesLeaderboard: [],
        pagination: null,
        ...action.payload
      };

    case SET_SALES_LEADERBOARD_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload.filters } };

    default:
      return { ...state };
  }
}
